import { useEffect, useRef } from "react";

const UNIT_MS = {
	minute: 60 * 1000,
	hour: 60 * 60 * 1000,
	day: 24 * 60 * 60 * 1000,
	week: 7 * 24 * 60 * 60 * 1000,
};

/**
 * How far the chart content moved when the range start changed from one
 * date to another, in pixels at the current scale.
 */
export const getRangeShiftPx = (previousStart, nextStart, scales) => {
	const unitMs = UNIT_MS[scales?.lengthUnit];
	const unitWidth = scales?.lengthUnitWidth;
	if (!previousStart || !nextStart || !unitMs || !unitWidth) return 0;

	return Math.round(
		((previousStart.getTime() - nextStart.getTime()) / unitMs) * unitWidth,
	);
};

/**
 * Keeps the same date under the left edge when the range start moves.
 *
 * The Gantt keeps its pixel scroll offset across a re-initialisation, so an
 * earlier range start would otherwise show earlier dates in the viewport.
 */
const useGanttScrollAnchor = ({ ganttApi, containerRef, rangeStart }) => {
	const previousStartRef = useRef(rangeStart);

	// Runs after the Gantt's own effects have applied the new range
	useEffect(() => {
		const previous = previousStartRef.current;
		previousStartRef.current = rangeStart;

		if (!ganttApi || !previous || !rangeStart) return;
		if (previous.getTime() === rangeStart.getTime()) return;

		const shift = getRangeShiftPx(previous, rangeStart, ganttApi.getState()?._scales);
		const chart = containerRef.current?.querySelector(".wx-chart");
		if (!shift || !chart) return;

		chart.scrollLeft += shift;
	}, [ganttApi, containerRef, rangeStart]);
};

export default useGanttScrollAnchor;
